<template>
  <div class="text-control-button">
    <button
      class="text-control-button__icon"
      @mouseover="toggleHovered = true" 
      @mouseleave="toggleHovered = false"
    >
      <slot />
    </button>
    <span :class="['text-control-button__text', { 'text-control-button__text--hovered' : toggleHovered }]">
     {{ text }}
    </span>
  </div>
</template>

<script setup lang="ts">

import { ref } from 'vue'

interface Props {
  text: string
}

const toggleHovered = ref(false)

defineProps<Props>()

</script>

<style lang="scss">

.text-control-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  &__text {
    opacity: 0;
    transition: opacity 150ms $animationCurve;
    color: $grey-10;
    font-family: $font-regular;
    font-size: 11px;
    line-height: 13px;
    justify-content: center;

    &--hovered {
      opacity: 1;
    }
  }

  &__icon {
    background: transparent;

    > svg {
      vertical-align: top;
    }

    &:hover {
      cursor: pointer;
    }
  }
}

</style>
